import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "@/hooks/useAuthentication";
import Root from "@/pages/Root";

const ProtectedRouter = () => {
  const isAuthed: boolean = useAuth();
  return isAuthed ? <Root /> : <Navigate to={"/"} replace />;
};

export default ProtectedRouter;
